// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__a36C2","default":"Spinner_default__-4Imr","lds-dual-ring":"Spinner_lds-dual-ring__gswb2"};